module.exports = __webpack_public_path__ + "static/media/272.f19e22cf.webp";